const styles = {
  root: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    p: 2,
    backgroundColor: 'primary.contrastText',
    width: '100%',
  },

  containerElements: {
    rowGap: 3,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    backgroundColor: 'common.secondaryEasy',
    maxWidth: '1000px',
    pt: 6,
    pr: 2,
    pl: 2,
    mb: 9,
    boxShadow: 'rgba(17, 12, 46, 0.15) 0px 30px 100px 0px',
  },

  title: {
    fontWeight: 600,
    display: 'flex',
    alignItems: 'flex-start',
    flexDirection: 'row',
    maxWidth: '700px',
    '& .MuiTypography-root': {
      color: 'text.primaryDark',
    },
  },

  subtitle: {
    maxWidth: '630px',
    '& .MuiTypography-root': {
      color: 'text.primaryDark',
    },
  },

  mainBanner: {
    width: { xs: '100%', lg: '800px' },
    height: '295px',
    display: { xs: 'none', md: 'block' },
  },

  mainBannerMobile: {
    width: '100%',
    display: { xs: 'block', md: 'none' },
  },

}

export default styles
